import serviceRequest from "utils/request";

const baseUrl = "/api/usefulLink";

export const getUsefulLinks = () => {
	return serviceRequest({
		url: `${baseUrl}/get-useful-links`,
		method: "get",
	});
};
